import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(({ spacing, palette }: any) => ({
  subCategoriesBar: {
    backgroundColor: palette.background.default,
    marginBottom: spacing(6),
    position: 'absolute',
    width: '100%',
  },
  scrollBar: {
    boxShadow: `inset 0px -2px 0px ${palette.action.activeOption}`,
    backgroundColor: palette.background.default,
    paddingRight: spacing(1),
    paddingLeft: spacing(1),
    alignItems: 'center',
    height: spacing(11),
    display: 'flex',
  },
  subCategory: {
    padding: `${spacing(1.5)}px ${spacing(2.5)}px`,
    backgroundColor: palette.action.inactive,
    color: palette.text.primary,
    minHeight: spacing(7.5),
    marginLeft: spacing(4),
    height: spacing(7.5),
    borderRadius: '4px',
    maxWidth: 'none',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  subCategorySelected: {
    backgroundColor: palette.primary.main,
    color: palette.text.contrastText,
    border: 'none',
  },
}));
